import { render, staticRenderFns } from "./BizSirenCallBackPhone.vue?vue&type=template&id=42a010b2&scoped=true&"
import script from "./BizSirenCallBackPhone.vue?vue&type=script&lang=ts&"
export * from "./BizSirenCallBackPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a010b2",
  null
  
)

export default component.exports